import cloneArrayBuffer from './_cloneArrayBuffer.js';

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

export default cloneDataView;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_cloneDataView.js
// module id = 1158
// module chunks = 0